import { uploadData } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';
import { getFfdUrl } from 'shared/api/ffdClient';

export const submitCFDStart = async (
  yamlConfig: string,
  authToken: string,
  cognitoId: string,
): Promise<void> => {
  // Generate random file names
  const yamlFileName = `${uuidv4()}.yml`;
  const yamlFilePath = `from-web-app/${cognitoId}/cfd-config/${yamlFileName}`;

  // Upload YAML file to S3
  try {
    const task = uploadData({
      path: yamlFilePath,
      data: yamlConfig
    });
    await task.result;
  } catch (error) {
    alert("Failed to upload .YAML to the server.");
  }

  // Send API request using uploaded YAML file
  try {
    const response = await fetch(getFfdUrl("/cfd/start"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken,
      },
      body: JSON.stringify({ yamlFilePath }),
    });

    const ct = response.headers.get('content-type') || '';
    const payload = ct.includes('application/json')
      ? await response.json().catch(async () => ({ text: await response.text() }))
      : await response.text();

    if (!response.ok) {
      const msg = typeof payload === 'string' ? payload : (payload?.message || JSON.stringify(payload));
      alert(`サーバエラー: HTTP ${response.status}\n${msg}`);
      return;
    }

    const message = typeof payload === 'string' ? payload : (payload?.text ?? JSON.stringify(payload));
    alert(message);
  } catch (error: any) {
    console.error(error);
    alert('通信エラー: 認証の有効期限やネットワーク状態を確認してください。');
  }
};
